var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codiceDownloadReferto"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-lg-10 offset-lg-1"},[_c('app-riattiva-utente',{attrs:{"service":"reactivate"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }